import { render, staticRenderFns } from "./PurchaseDone.vue?vue&type=template&id=6b023a08&scoped=true&"
import script from "./PurchaseDone.vue?vue&type=script&lang=js&"
export * from "./PurchaseDone.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseDone.vue?vue&type=style&index=0&id=6b023a08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b023a08",
  null
  
)

export default component.exports